export const DASHBOARD = 'DASHBOARD'
export const COURSES = 'COURSES'
export const PLATFORM = 'PLATFORM'
